module.exports = __webpack_public_path__ + "static/media/nh-icon-selfcare.6a94ee77.png";